import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { applyPriceMarkup } from '../utils/priceUtils';
import '../styles/ProductCard.css';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  // Check if image is a color (hex code) or URL
  const isColor = product.image && product.image.startsWith('#');

  // Don't render if product is not available
  if (product.available === false) {
    return null;
  }

  // Apply 10% markup and round to nearest 5 or 0
  const displayPrice = applyPriceMarkup(product.price);

  const handleAddToCart = () => {
    // Create product with marked-up price
    const productWithMarkup = {
      ...product,
      price: displayPrice
    };
    addToCart(productWithMarkup);
  };

  return (
    <div className="product-card">
      {isColor ? (
        <div className="product-color-box" style={{ backgroundColor: product.image }}>
          <span className="product-name-overlay">{product.name}</span>
        </div>
      ) : (
        <img src={product.image} alt={product.name} />
      )}
      <div className="product-info">
        <h3>{product.name}</h3>
        <p className="product-description">{product.description}</p>
        <div className="product-footer">
          <span className="product-price">₹{displayPrice}</span>
          <div className="product-actions">
            <Link to={`/product/${product.id}`} className="btn-view">
              View Details
            </Link>
            <button onClick={handleAddToCart} className="btn-add">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
